import React, { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import { Svg } from 'ui'
import ServiceFilteringIcon from 'images/organization/features/serviceFiltering/comprehensive-service-filtering-icon.svg'
import ProtectionBg from 'images/organization/features/malware/protection-bg.svg'
import ServiceBlockingIllustration from 'images/organization/features/serviceFiltering/predefined-service-blocking.png'
import CustomRulesIllustration from 'images/organization/features/serviceFiltering/custom-rules.png'
import ProfileManagementIllustration from 'images/organization/features/serviceFiltering/profile-management.png'
import { Link } from 'gatsby'
import { TextWithBreakpointVariant } from 'ui/TextWithBreakpointVariant'
import CommonSectionItem from 'components/Organization/LandingPageCommonComponents/CommonSectionItem'

export default function ComprehensiveServiceFiltering(): ReactElement {
  return (
    <Flex
      sx={{
        width: '100%',
        flexDirection: 'column',
        gap: ['4.2rem', '4.8rem'],
        justifyContent: 'center',
        textAlign: 'center',
        px: '1.6rem',
        mb: '4.8rem',
      }}
    >
      <Flex
        sx={{ position: 'relative', flexDirection: 'column', gap: '1.6rem', alignItems: 'center' }}
      >
        <Svg svg={ServiceFilteringIcon} descriptiveText="Service filtering section icon" />
        <TextWithBreakpointVariant
          variant={['size24Weight600', 'size40Weight600']}
          sx={{ color: 'white', mt: '-4rem', zIndex: 'zIndex1' }}
        >
          Comprehensive service filtering
        </TextWithBreakpointVariant>
        <Svg
          svg={ProtectionBg}
          sx={{ position: 'absolute', top: '-5rem', width: ['70rem', 'auto'], zIndex: 'zIndex0' }}
          descriptiveText="Decorative background for service filtering section"
        />
      </Flex>
      <Flex
        sx={{ flexDirection: 'column', gap: '6.4rem', alignItems: 'center', zIndex: 'zIndex2' }}
      >
        <CommonSectionItem
          image={ServiceBlockingIllustration}
          title="Predefined service blocking"
          description={
            <Text>
              Block{' '}
              <Link to="/available-services" style={{ textDecoration: 'none' }}>
                <Text
                  sx={{
                    color: 'wildBlueYonder',
                    textDecoration: 'underline',
                  }}
                >
                  popular services and applications
                </Text>
              </Link>
              , such as social media, entertainment, or torrent sites, with easy-to-use predefined
              filtering settings. This helps businesses instantly apply security policies and
              maintain workplace productivity.
            </Text>
          }
        />
        <CommonSectionItem
          image={CustomRulesIllustration}
          isReverse
          title="Custom rules"
          description="Create and enforce custom rules to block specific services based on your organization’s needs.
           You decide which services are allowed or restricted, providing granular control over your network’s web access."
        />
        <CommonSectionItem
          image={ProfileManagementIllustration}
          title="Flexible profile management"
          description="Manage access based on user roles or device types, giving you the flexibility to tailor filtering policies.
           This feature allows you to adjust access settings for different teams, departments, or specific devices,
            ensuring the right level of control."
        />
      </Flex>
    </Flex>
  )
}
